import React from "react";
import "../App.css"
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Link } from '@material-ui/core';
import history from '.././history';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import Star from '@material-ui/icons/Star';
import StarHalf from '@material-ui/icons/StarHalf';
import StarBorder from '@material-ui/icons/StarBorder';
import LocationOnIcon from '@material-ui/icons/LocationOn';

function StarRating({ rating }) {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    if (rating >= i) {
      stars.push(<Star key={i} style={{ color: '#FFD700', fontSize: '18px' }} />);
    } else if (rating >= i - 0.5) {
      stars.push(<StarHalf key={i} style={{ color: '#FFD700', fontSize: '18px' }} />);
    } else {
      stars.push(<StarBorder key={i} style={{ color: '#FFD700', fontSize: '18px' }} />);
    }
  }
  return <span style={{ display: 'inline-flex', alignItems: 'center' }}>{stars}</span>;
}

function StudioCard({ name, mapLink, workoutRating, studioRating, review }) {
  return (
    <Card className="review-card-container">
      <CardContent className="review-card-content">
        <Typography gutterBottom variant="h5" component="h2" className="card-text">
          {name}
        </Typography>

        {mapLink && (
          <Typography variant="body2" component="p" className="card-text" style={{ marginBottom: '8px' }}>
            <Link href={mapLink} target="_blank" rel="noopener noreferrer" className="card-text" style={{ display: 'inline-flex', alignItems: 'center' }}>
              <LocationOnIcon style={{ fontSize: '18px', marginRight: '4px' }} />
              View on Map
            </Link>
          </Typography>
        )}

        <Typography variant="body2" component="p" className="card-text" style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
          Workout:&nbsp;<StarRating rating={workoutRating} />
        </Typography>

        <Typography variant="body2" component="p" className="card-text" style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
          Studio:&nbsp;<StarRating rating={studioRating} />
        </Typography>

        <Typography variant="body2" component="p" className="card-text">
          {review}
        </Typography>
      </CardContent>
    </Card>
  );
}

function PilatesReview() {

  return (
    <div className="App">
      <div className="back"><Button onClick={onClick}><ArrowBackOutlinedIcon color="primary" /></Button></div>

      <header className="App-header">
        <h1>Pilates & Lagree Studio Reviews</h1>

        <Typography variant="body2" component="p" className="card-text" style={{ marginBottom: '20px', maxWidth: '600px', textAlign: 'left' }}>
          <strong>Workout rating:</strong> Intensity, amount of burn, techniques, teaching style<br />
          <strong>Studio:</strong> Amenities, decorations
        </Typography>

        <StudioCard
          name="Blood, Sweat & Tears"
          mapLink="https://maps.app.goo.gl/BiUJNigaN96mkohk6"
          workoutRating={5}
          studioRating={4}
          review="First few sessions literally killed me and it got better after I went 4-5 times. I notice a huge improvement in my core. Good location, cute view from the studio, but limited changing space and no shower."
        />

        <StudioCard
          name="Studio Anatomy (Islington)"
          mapLink="https://maps.app.goo.gl/B13Ft6kMvoiaSoTy9"
          workoutRating={4}
          studioRating={5}
          review="Went to an intermediate class and the workout is very on point for thighs. There are some leg raising exercise which I have never come across in other studios. Super cute vibes in the studio. Really nice decorations."
        />

        <StudioCard
          name="LevelOut St Paul's"
          mapLink="https://maps.app.goo.gl/qH3WZ1jH2QJ3rHVt6"
          workoutRating={3.5}
          studioRating={4}
          review="Nice location, the class itself is pretty average, attentive instructor though."
        />

        <StudioCard
          name="Gymbox (Farringdon)"
          mapLink="https://maps.app.goo.gl/uAHW7rXEf8zVMmnq7"
          workoutRating={3}
          studioRating={4}
          review="I have only tried the reformer class at Farringdon so far, but the decoration is new and kind of cute. Class is quite large, pretty average. The 'power' class uses weights, much more intense than the 'tone' class."
        />

        <StudioCard
          name="Strong (Warren Street)"
          mapLink={null}
          workoutRating={4}
          studioRating={4}
          review="Quite a tough workout for the weights used. Definitely pause here and there for breaks. It is a big class - I never see the instructor giving any personal attention to individuals."
        />

        <StudioCard
          name="1Rebel"
          mapLink={null}
          workoutRating={4}
          studioRating={5}
          review="Immersive dark room vibe workout class - biggest class (20+ beds) I have been so far, so limited personal attention. But 5/5 on the vibe and music. I do feel like you sweat differently in dark rooms."
        />

        <StudioCard
          name="Victus Soul (Aldgate)"
          mapLink="https://maps.app.goo.gl/TapTzHpiicRusjb5A"
          workoutRating={4.5}
          studioRating={5}
          review="Honestly I really like this studio, good use of weights (more on building muscles) and energetic instructors."
        />

        <StudioCard
          name="LOAD Strength Reformer"
          mapLink="https://maps.app.goo.gl/KJBJvhzL2NEVLGEP6"
          workoutRating={5}
          studioRating={4}
          review="The most intense reformer class I have been to. The class size is small (6 beds only) so you have quite a lot of personal attention. The class start you on 2 reds + 1 blue springs (which is already the easy option), minimum 6Kg dumbells. I went on a random Friday at 10am and 2 of the (middle aged) ladies in my class were super fit with 6 packs. They are so strong..."
        />

      </header>
    </div>
  );
}

function onClick() {
  history.push("/hub");
}

export default PilatesReview;
